import fetch from 'cross-fetch'
import Axios from 'axios';
import { browserHistory } from 'react-router';
import { getRequest, postRequest, putRequest } from '../../utils/apiUtils';
var request = require('request');

export const CHECK_EXIST_CONTRACT_FACILITY='CHECK_EXIST_CONTRACT_FACILITY'
export const CONTRACT_PEROIDICALS='CONTRACT_PEROIDICALS'
export const CREATE_CONTRACT_FACILTY_PERIODICAL='CREATE_CONTRACT_FACILTY_PERIODICAL'
export const CONTRACT_FACILITY_DATA='CONTRACT_FACILITY_DATA'
export const UPDATE_CONTRACT_PERIODICAL='UPDATE_CONTRACT_PERIODICAL'
export const CHECK_IN_PROGRESS_PERIODICAL='CHECK_IN_PROGRESS_PERIODICAL'
export const DELETE_PERIODICAL_DATA='DELETE_PERIODICAL_DATA'
export const RESET_DRAG_PERIODICAL='RESET_DRAG_PERIODICAL'


// const header={"device-type": "AML9327483","token-id":"aGlyZW5AbWFqZXN0aWNzZXJ2aWNlc2dyb3VwLmNvbS5hdTpoaXJlbjoyNTEx"};

/* check exist function */
  function isExistContractFacility(post) {
    return async dispatch => {
        return await postRequest({ url: '/api/isexist_contract_facility_periodicals', payload: post}
         )
        .then(response => {
            dispatch(existContractFacility(response.data))
        })
        .catch(error => {
          if (error.response) 
						{
							if(error.response.status===403)
							{
								browserHistory.push('/');
								window.location.reload(); 
							}
							else
							{
								console.log(error);
							}
						}
        });
    }
  }

  function existContractFacility(response) {
    return {
      type: CHECK_EXIST_CONTRACT_FACILITY,
      is_exist_contract_facility: response
    }
  }

   export function checkExistContractFacility(post) {
    return (dispatch) => {
        return dispatch(isExistContractFacility(post))
    }
  }

  /* check exist function end */

  /*managed_contract_periodicals crate */

  function contractPeridicals(id) {
    return async dispatch => {
        return await getRequest({ url: '/api/managed_contract_periodicals/'+id}
         )
        .then(response => {
          //console.log(response);
          if(response.data.result.length>0)
          {
            dispatch(requestContractPeridicals(response.data.result))
          }
          else
          {
            dispatch(requestContractPeridicals([]))
          }
        })
        .catch(error => {
          if (error.response) 
						{
							if(error.response.status===403)
							{
								browserHistory.push('/');
								window.location.reload(); 
							}
							else
							{
								console.log(error);
							}
						}
        });
    }
  }

  function requestContractPeridicals(response) {
    return {
      type: CONTRACT_PEROIDICALS,
      contract_peridicals_data: response
    }
  }

   export function createContractPeridicals(post) {
    return (dispatch) => {
        return dispatch(contractPeridicals(post))
    }
  }

/*managed_contract_periodicals end */


/* create contract facility peridicals */

function createContractFacility(post) {
  return async dispatch => {
      return await postRequest({ url: '/api/managed_contract_facility_periodicals', payload: post}
        )
      .then(response => {
          dispatch(insertContractPeriodicals(response.data))
      })
      .catch(error => {
        if (error.response) 
        {
          if(error.response.status===403)
          {
            browserHistory.push('/');
            window.location.reload(); 
          }
          else
          {
            console.log(error);
          }
        }
      });
  }
}

function insertContractPeriodicals(response) {
  return {
    type: CREATE_CONTRACT_FACILTY_PERIODICAL,
    allocation_response: response
  }
}

 export function createContractFacilityPeriodicals(post) {
  return (dispatch) => {
      return dispatch(createContractFacility(post))
  }
}
/* end */


/* create contract facility peridicals */

function getContractFacilityData(id) {
  return async dispatch => {
      return await getRequest({ url: '/api/managed_contract_facility_periodicals/'+id}
       )
      .then(response => {

          if(response.data.result.length>0)
          {
            dispatch(fethContractFacilityPeridicals(response.data.result))
          }
          else
          {
            dispatch(fethContractFacilityPeridicals([]))
          }
      })
      .catch(error => {
        if (error.response) 
						{
							if(error.response.status===403)
							{
								browserHistory.push('/');
								window.location.reload(); 
							}
							else
							{
								console.log(error);
							}
						}
      });
  }
}

function fethContractFacilityPeridicals(response) {
  return {
    type: CONTRACT_FACILITY_DATA,
    contract_facilitys_data: response
  }
}

 export function contractFacilityPeriodicalsData(id) {
  return (dispatch) => {
      return dispatch(getContractFacilityData(id))
  }
}
/* end */

/* update peridical */

function updateContractFacility(post) {
  return async dispatch => {
      return await putRequest({ url: '/api/managed_contract_facility_periodicals', payload: post}
        )
      .then(response => {
         dispatch(updateData(response.data))
      })
      .catch(error => {
        if (error.response) 
						{
							if(error.response.status===403)
							{
								browserHistory.push('/');
								window.location.reload(); 
							}
							else
							{
								console.log(error);
							}
						}
      });
  }
}

function updateData(response) {
  return {
    type: UPDATE_CONTRACT_PERIODICAL,
    allocation_response: response
  }
}

 export function updateFacilityPeriodicalsData(post) {
  return (dispatch) => {
      return dispatch(updateContractFacility(post))
  }
}


/* end */


/* check working periodical */
function checkWorkingPeridical(id) {
  return async dispatch => {
      return await getRequest({ url: '/api/is_working_peridical/'+id}
       )
      .then(response => {
          dispatch(workingFacilityperiodical(response.data))
      })
      .catch(error => {
        if (error.response) 
						{
							if(error.response.status===403)
							{
								browserHistory.push('/');
								window.location.reload(); 
							}
							else
							{
								console.log(error);
							}
						}
      });
  }
}

function workingFacilityperiodical(response) {
  return {
    type: CHECK_IN_PROGRESS_PERIODICAL,
    is_working_count: response
  }
}

 export function isWorkingOnPeriodical(id) {
  return (dispatch) => {
      return dispatch(checkWorkingPeridical(id))
  }
}

/* check exist function end */

/* remove faciliy periodicals */
function removeFacilityPeriodicals(id) {
  return async dispatch => {
    return await getRequest({ url: '/api/remove_facility_contrct/' + id })
      .then(response => {

        if (response.data && response.data.status === false) {
          return response.data;
        }

        dispatch(removeData(id));
        return response.data;

      })
      .catch(error => {
        if (error.response) {
          if (error.response.status === 403) {
            browserHistory.push('/');
            window.location.reload();
          } else {
            console.log(error);
          }
        }
      });
  }
}

function removeData(response) {
  return {
    type: DELETE_PERIODICAL_DATA,
    allocation_response: response
  }
}

 export function removeFacilityPeriodical(id) {
  return (dispatch) => {
      return dispatch(removeFacilityPeriodicals(id))
  }
}
/*end */

/* remove faciliy periodicals */
function resetFacilityPeriodicals(id) {
  return async dispatch => {
      return await getRequest({ url: '/api/on_drag_delete_periodical/'+id}
        )
      .then(response => {
         dispatch(resetData(response.data))
      })
      .catch(error => {
        if (error.response) 
        {
          if(error.response.status===403)
          {
            browserHistory.push('/');
            window.location.reload(); 
          }
          else
          {
            console.log(error);
          }
        }
      });
  }
}

function resetData(response) {
  return {
    type: RESET_DRAG_PERIODICAL,
    allocation_response: response
  }
}

 export function resetFacilityPeriodical(id) {
  return (dispatch) => {
      return dispatch(resetFacilityPeriodicals(id))
  }
}
/*end */


// WEBPACK FOOTER //
// ./src/shared/actions/allocation_action.js